import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessAdministratorsResponse } from '../models/business-administrators.model';
import { fromGetBusinessAdministrators } from '../actions';
import { IGetDirectorsResponse } from '../models/get-directors.model';

export const businessAdministratorsFeatureKey = 'businessAdministrators';

export interface BusinessAdministratorsState {
  loadBusinessAdministratorsResponse: IGetDirectorsResponse[];
  loadBusinessAdministratorsFailure: IGenericError<ErrorResponse>;
}

export const initialState: BusinessAdministratorsState = {
  loadBusinessAdministratorsResponse: undefined,
  loadBusinessAdministratorsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromGetBusinessAdministrators.loadBusinessAdministratorsSuccess, (state, action) => ({
    ...state,
    loadBusinessAdministratorsResponse: action.response
  })),
  on(fromGetBusinessAdministrators.loadBusinessAdministratorsFailure, (state, action) => ({
    ...state,
    loadBusinessAdministratorsFailure: action.error
  })),
  on(fromGetBusinessAdministrators.clearBusinessAdministrators, (state, action) => ({
    ...state,
    loadBusinessAdministratorsResponse: undefined
  }))
);

export const getBusinessAdministratorsResponse = (state: BusinessAdministratorsState) => state.loadBusinessAdministratorsResponse;
